import { render, staticRenderFns } from "./TS-tab.vue?vue&type=template&id=51918209"
import script from "./TS-tab.vue?vue&type=script&lang=js"
export * from "./TS-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports